import { useEffect, useCallback } from "react";
import { useParameter, useFavouriteProviderContext } from "../../../shared";

import { useSlideTitle } from "../hooks/useSlideTitle";

export function useFavourite() {
  const title = useSlideTitle();
  const {
    actions: { setParameters, setApplyFunction },
  } = useFavouriteProviderContext();

  const [commodities, setCommodities] = useParameter<number[]>("@commodities");
  const [commDisplay, setCommDisplay] = useParameter<number[]>("@commodities_display");

  useEffect(() => {
    setParameters(title, {
      "@commodities": commodities,
      "@commodities_display": commDisplay,
    });
  }, [title, commodities, commDisplay, setParameters]);

  const applyParameters = useCallback(
    (parameters: Record<string, string[]>) => {
      setCommodities(parameters["@commodities"].map(Number));
      setCommDisplay(parameters["@commodities_display"].map(Number));
    },
    [setCommodities, setCommDisplay]
  );

  useEffect(() => {
    setApplyFunction(applyParameters);
  }, [setApplyFunction, applyParameters]);
}
